import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)<{ className?: string }>`
  stroke: none;
  color: ${(props: { className?: string }) =>
    props.className && props.className === 'warning' ? '#f8bb86' : '#da4848'};
  width: 12px;
  height: 12px;
`

const ErrorSmall = ({ title = 'Warning', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
    <path
      fill="currentColor"
      d="M15.8,12.526,9.483.88A1.668,1.668,0,0,0,8.8.2,1.693,1.693,0,0,0,6.516.88L.2,12.526A1.678,1.678,0,0,0,1.686,15H14.314a1.7,1.7,0,0,0,.8-.2,1.673,1.673,0,0,0,.687-2.274ZM8,13a1,1,0,1,1,1-1A1,1,0,0,1,8,13ZM9,9.5a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,9.5v-4A.5.5,0,0,1,7.5,5h1a.5.5,0,0,1,.5.5Z"
    ></path>
  </StyledIcon>
)

ErrorSmall.displayName = 'ErrorIcon'
ErrorSmall.needsWork = true
export default ErrorSmall
